module.exports = __webpack_public_path__ + "media/images/bright_quote-924e92f547d6c924e6ad4a1acbdd3dd6.svg";